import { Button, Modal, Stack, Typography, useTheme } from "@mui/material";
import type { DocumentDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { useCloseOnBackPress } from "web_myplann/Shared/Hooks/useCloseOnBackPress";

type Props = {
	document: DocumentDTO;
	open: boolean;
	onClose: (result: boolean) => void;
};

export const DeleteDocumentDialog = ({ document, open, onClose }: Props) => {
	const { t } = useResource();
	const theme = useTheme();
	const handleCancel = () => onClose(false);
	useCloseOnBackPress(open, handleCancel);

	return (
		<Modal open={open} onClose={handleCancel}>
			<Stack
				bgcolor={theme.palette.common.white}
				p={2}
				borderRadius={1.6}
				gap={1.6}
				position="absolute"
				top="50%"
				left="50%"
				minWidth="80%"
				sx={{ transform: "translate(-50%, -50%)" }}
			>
				<Typography variant="deprecatedH3">
					{t(Resources.Portfolio.List.DeleteDocumentDialog.title)}
				</Typography>
				<Typography>
					{t(Resources.Portfolio.List.DeleteDocumentDialog.description, {
						documentName: document.title,
					})}
				</Typography>
				<Stack direction="row" gap={1.6} justifyContent={"flex-end"}>
					<Button
						variant="text"
						onClick={handleCancel}
						sx={{ color: theme.palette.common.black }}
					>
						{t(Resources.Portfolio.List.DeleteDocumentDialog.cancel)}
					</Button>
					<Button variant="text" onClick={() => onClose(true)}>
						{t(Resources.Portfolio.List.DeleteDocumentDialog.confirm)}
					</Button>
				</Stack>
			</Stack>
		</Modal>
	);
};
